import type { PMServiceLevel } from '../../types/pmTypes';

export type ServiceLevelDraft = {
    id: string;
    levelIdentifier: string;
    intervalValue: string;
};

export function draftsFromServiceLevels(
    levels: Pick<PMServiceLevel, 'id' | 'levelIdentifier' | 'intervalValue'>[],
): ServiceLevelDraft[] {
    return levels.map((level) => ({
        id: level.id,
        levelIdentifier: level.levelIdentifier,
        intervalValue: String(level.intervalValue),
    }));
}

export function validateServiceLevelDrafts(rows: ServiceLevelDraft[]): string {
    const names = new Set<string>();
    for (const row of rows) {
        const name = row.levelIdentifier.trim();
        if (!name) return 'Each level needs a name.';
        const interval = parseFloat(row.intervalValue);
        if (!row.intervalValue.trim() || Number.isNaN(interval) || interval <= 0) {
            return 'Each level needs a positive interval.';
        }
        const key = name.toLowerCase();
        if (names.has(key)) return 'Level names must be unique.';
        names.add(key);
    }
    return '';
}
